module.exports = __webpack_public_path__ + "img/VL_08_03.88720833.png";